import { ReactNode } from "react";

import ChooseEntityViewMulti from "./ChooseEntityViewMulti";
import { ChooseEntityViewSingle } from "./ChooseEntityViewSingle";

import { Entity, EntityType } from "@/queries";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

interface SingleModeContentProps {
  mode: "single";
  onSelect: (entity: Entity) => void;
  selectedEntity?: Entity;
  type: EntityType;
  currentFolderId: number | null;
  readonly?: boolean;
}

interface MultiModeContentProps {
  mode: "multi";
  onSelect: (entities: Entity[]) => void;
  selectedEntities?: Entity[];
  min?: number;
  max?: number;
  type: EntityType;
  currentFolderId: number | null;
  readonly?: boolean;
}

type ContentProps = SingleModeContentProps | MultiModeContentProps;

const ChooseEntityDialogContent = ({
  open,
  onOpenChange,
  children,
  ...props
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children?: ReactNode;
} & ContentProps) => {
  const mode = props.mode || "single";

  const handleMultiConfirm =
    mode === "multi"
      ? (entities: Entity[]) => {
          const multiProps = props as MultiModeContentProps;
          multiProps.onSelect(entities);
          onOpenChange(false);
        }
      : undefined;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}

      <DialogContent className="flex h-full max-h-[720px] max-w-4xl flex-col gap-0 p-0">
        {mode === "multi" ? (
          <ChooseEntityViewMulti
            open={open}
            type={props.type}
            currentFolderId={props.currentFolderId}
            readonly={props.readonly}
            selectedEntities={(props as MultiModeContentProps).selectedEntities}
            min={(props as MultiModeContentProps).min}
            max={(props as MultiModeContentProps).max}
            onConfirm={handleMultiConfirm!}
            onCancel={() => onOpenChange(false)}
          />
        ) : (
          <ChooseEntityViewSingle
            type={props.type}
            currentFolderId={props.currentFolderId}
            readonly={props.readonly}
            selectedEntity={(props as SingleModeContentProps).selectedEntity}
            onSelect={(props as SingleModeContentProps).onSelect}
            onClose={() => onOpenChange(false)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ChooseEntityDialogContent;
